export const ENROLMENT_MODAL_MODE_CLASS_SELECTION =
  'ENROLMENT_MODAL_MODE_CLASS_SELECTION';

export const ENROLMENT_MODAL_MODE_ACCESS_CODE =
  'ENROLMENT_MODAL_MODE_ACCESS_CODE';

export const ENROLMENT_MODAL_MODE_EXTERNAL_ENROLMENT =
  'ENROLMENT_MODAL_MODE_EXTERNAL_ENROLMENT';

export const ENROLMENT_MODAL_MODE_PAID_ENROLMENT =
  'ENROLMENT_MODAL_MODE_PAID_ENROLMENT';

export const ENROLMENT_MODAL_MODE_ERROR = 'ENROLMENT_MODAL_MODE_ERROR';

export const ENROLMENT_MODAL_MODES = [
  ENROLMENT_MODAL_MODE_CLASS_SELECTION,
  ENROLMENT_MODAL_MODE_ACCESS_CODE,
  ENROLMENT_MODAL_MODE_EXTERNAL_ENROLMENT,
  ENROLMENT_MODAL_MODE_PAID_ENROLMENT,
  ENROLMENT_MODAL_MODE_ERROR,
];

export const ENROLMENT_CLASS_SELECTION_DEFAULT_COHORT = 'defaultCohort';
export const ENROLMENT_CLASS_SELECTION_ACCESS_CODE = 'accessCode';

export const ENROLMENT_CLASS_SELECTION_OPTIONS = [
  ENROLMENT_CLASS_SELECTION_DEFAULT_COHORT,
  ENROLMENT_CLASS_SELECTION_ACCESS_CODE,
];
